<template>
  <auth-redirect-form
      ref="form"
      :source="source"
      :occup-id="occupId"
      :token="token"
      :username="username"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import AuthRedirectForm from '@/components/AuthRedirectForm';

export default {
  name: 'auth-redirect',
  components: {
    AuthRedirectForm,
  },
  data () {
    return {
      source: this.$route.query.source,
      occupId: this.$route.query.occupId,
      token: this.$route.query.token,
      username: this.$route.query.username,
    };
  },
  computed: {
    ...mapGetters('user', [
      'isLoggedIn',
    ]),
    canBeAuthenticated () {
      return this.token || this.isLoggedIn;
    },
  },
  async mounted () {
    await this.$store.dispatch('user/status');
    this.$watch('canBeAuthenticated', {
      handler (value) {
        if (value) {
          this.$refs.form.submit();
        } else {
          this.$router.push({
            name: 'login',
            query: {
              redirect: this.$router.currentRoute.fullPath,
            },
          });
        }
      },
      immediate: true,
    });
  },
};
</script>
